export default __webpack_public_path__ + "static/media/error404_light.6d3f8dee.svg";